<template>
    <div>
    <rkm-table
        :items="laboratorios"
        :fields="fields"
        sort-by="nomeFantasia"
    >
        <template v-slot:head(percentualFinanceiro)>
            % Cota Financeira APP
            <rkm-icon
                icon="info"
                color="secondary"
                class="infor"
                small
                v-rkm-popover.hover.left="{
                    html: true,
                    content: 'A cota definida para o APP Cidadão não é de uso exclusivo do aplicativo. Ela pode ser consumida também pela operação interna, conforme a concorrência natural da cota total do prestador.'
                }"
            />
        </template>

        <template v-slot:head(percentualQuantitativo)>
            % Cota Física APP
            <rkm-icon
                icon="info"
                color="secondary"
                class="infor"
                small
                v-rkm-popover.hover.left="{
                    html: true,
                    content: 'A cota definida para o APP Cidadão não é de uso exclusivo do aplicativo. Ela pode ser consumida também pela operação interna, conforme a concorrência natural da cota total do prestador.'
                }"
            />
        </template>

        <template v-slot:cell(percentualFinanceiro)="{ item }">
            <rkm-form-input
                v-if="item.cotaValorTotal > 0"
                v-model.number="item.percentualFinanceiro"
                number
                :name="`percentual_financeiro_lab_${item.infraestruturaId}`"
            />
            <span v-else class="text-muted">—</span>
        </template>

        <template v-slot:cell(cotaFinanceiraApp)="{ item }">
            <span v-if="item.cotaValorTotal > 0 && item.percentualFinanceiro !== null">
                R$ {{ calcularCotaValor(item.cotaValorTotal, item.percentualFinanceiro) }}
            </span>
            <span v-else class="text-muted">—</span>
        </template>

        <template v-slot:cell(percentualQuantitativo)="{ item }">
            <rkm-form-input
                v-if="item.cotaQuantidadeTotal > 0"
                v-model.number="item.percentualQuantitativo"
                number
                :name="`percentual_quantitativo_lab_${item.infraestruturaId}`"
            />
            <span v-else class="text-muted">—</span>
        </template>

        <template v-slot:cell(cotaQuantitativaApp)="{ item }">
            <span v-if="item.cotaQuantidadeTotal > 0 && item.percentualQuantitativo !== null">
                {{ calcularCotaQuantidade(item.cotaQuantidadeTotal, item.percentualQuantitativo) }} exames
            </span>
            <span v-else class="text-muted">—</span>
        </template>

        <template v-slot:cell(detalhes)="{ item }">
            <rkm-button
                color="secondary"
                small
                @click="$refs.ModalDetalhes.open(item)"
                title="Ver detalhes por período"
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-table>

    <ModalDetalhes ref="ModalDetalhes" />
    </div>
</template>

<script>
import ModalDetalhes from '../ModalDetalhes'

export default {
    components: { ModalDetalhes },

    props: {
        laboratorios: { required: true, type: Array },
    },

    computed: {
        fields() {
            return [
                { key: 'nomeFantasia', label: 'Laboratório', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'percentualFinanceiro', label: '% Cota Financeira APP', class: 'text-center col-min' },
                { key: 'cotaFinanceiraApp', label: 'Cota Financeira disponível ao APP', class: 'text-center' },
                { key: 'percentualQuantitativo', label: '% Cota Física APP', class: 'text-center col-min' },
                { key: 'cotaQuantitativaApp', label: 'Cota Física disponível ao APP', class: 'text-center' },
                { key: 'detalhes', label: '', class: 'col-min text-center' },
            ]
        },
    },

    methods: {
        calcularCotaQuantidade(quantidade, percentual) {
            return Math.floor((parseInt(quantidade) || 0) * (Number(percentual) || 0) / 100)
        },

        calcularCotaValor(valor, percentual) {
            const resultado = Math.floor((parseFloat(valor) || 0) * (Number(percentual) || 0) / 100 * 100) / 100
            return resultado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
    },
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
